
/**
* Component is lazy-loaded
* http://router.vuejs.org/en/advanced/lazy-loading.html
*/

import store from '../../store'

const Nettmeny = (resolve) => {
  require.ensure(['./main'], () => {
    resolve(require('./main')) // eslint-disable-line global-require
  })
}

const Contract = (resolve) => {
  require.ensure(['./Contract'], () => {
    resolve(require('./Contract'))
  })
}

const ContractsList = (resolve) => {
  require.ensure(['./ContractsList'], () => {
    resolve(require('./ContractsList'))
  })
}

const NewMenu = (resolve) => {
  require.ensure(['./NewMenu'], () => {
    resolve(require('./NewMenu'))
  })
}

const ArticlesAdd = (resolve) => {
  require.ensure(['./ArticlesAdd/main'], () => {
    resolve(require('./ArticlesAdd/main'))
  })
}

const Delivery = (resolve) => {
  require.ensure(['./Delivery/DeliveryMain'], () => {
    resolve(require('./Delivery/DeliveryMain'))
  })
}

const meta = {
  requiresAuth: true
}

const beforeEnter = (to, from, next) => {
  if (!store.getters.hasModuleContracts) {
    next({ path: '/' })
  }
  next()
}

export default [
  {
    name: 'menus',
    path: '/menus',
    component: Nettmeny,
    meta,
    beforeEnter,
    children: [
      {
        name: 'contractlist',
        path: 'contractlist',
        component: ContractsList,
        meta,
      },
      {
        name: 'contract',
        path: 'contract/:contractNo',
        component: Contract,
        props: true,
        meta,
      },
      {
        name: 'articles.add',
        path: 'articles',
        component: ArticlesAdd,
        meta,
      },
      {
        name: 'newmenu',
        path: 'newmenu',
        component: NewMenu,
        meta,
      },
      {
        name: 'delivery.index',
        path: 'delivery',
        component: Delivery,
        meta,
      }
    ],
  },

]



// WEBPACK FOOTER //
// ./src/app/contracts/routes.js